module.exports = __webpack_public_path__ + "img/zuijia_11.a7433798.png";